import React from "react";
import Layout from "../components/layout/Layout";
import { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import getMobileOS from "../utils/getOS";
import api from "./api/base-url";
import compareTime from "../utils/compareTime";
import LinkExpired from "./LinkExpired";
import LoadingPage from "./LoadingPage";
import DownloadElements from "../components/download-components/DesktopComponents";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Version, LinkToShare } from "../components/apps-components/apps-types";
import { loginRequest } from "../authConfig";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import {
  InteractionRequiredAuthError,
  InteractionType,
  InteractionStatus,
} from "@azure/msal-browser";
import reportWebVitals from "../reportWebVitals";
import WelcomePage from "./WelcomePage";
import axiosInstance from "./api/base-url";
import LoginLayout from "../components/layout/LoginLayout";
import Footer from "../components/layout/Footer";

function DownloadPage(props: { auth?: boolean }) {
  const [link, setLink] = useState<LinkToShare>();
  const [progress, setProgress] = useState(0);
  const [platform, setPlatform] = React.useState("");
  const [acquiringToken, setAcquiringToken] = useState(false);
  const [token, setToken] = useState<string | null>(null);

  let params = useParams();
  const uuid = params.uuid;
  let urlForManifest;
  const os = getMobileOS();

  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (props.auth && localStorage.getItem("IdToken") === null) {
      setAcquiringToken(true);

      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      instance
        .acquireTokenSilent(request)
        .then((response) => {
          localStorage.setItem("Token", response.accessToken);
          localStorage.setItem("IdToken", response.idToken);
          localStorage.setItem(
            "Name",
            JSON.parse(atob(response.accessToken.split(".")[1]))["given_name"]
          );
          localStorage.setItem(
            "Surname",
            JSON.parse(atob(response.accessToken.split(".")[1]))["family_name"]
          );
          setToken(response.idToken);

          axiosInstance.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.idToken}`;

          setAcquiringToken(false);
        })
        .catch(async (e) => {
          if (e instanceof InteractionRequiredAuthError) {
            await instance.acquireTokenRedirect(request);
          }
        });
    }
  }, [isAuthenticated, accounts, instance, props.auth, acquiringToken]);

  useEffect(() => {
    const checkLinkValidity = async () => {
      try {
        /* if (localStorage.getItem("IdToken") !== null) */
        if (
          props.auth &&
          localStorage.getItem("IdToken") !== null &&
          acquiringToken !== true
        ) {
          const response = await api.get(`/links/auth/${uuid}`);
          setLink(response.data);
          checkPlatform(response.data.versions);
        } else if (!props.auth) {
          const response = await api.get(`/links/${uuid}`);
          setLink(response.data);
          checkPlatform(response.data.versions);
        }
      } catch (err: any) {
        if (err.response) {
          //Not in 200 response range
          console.log(err.response.data);
          console.log(err.response.status);
        } else {
          console.log(`Error: ${err.message}`);
        }
      }
    };
    checkLinkValidity();
  }, [props.auth, uuid, token, acquiringToken]);

  function checkPlatform(versions: Version[]) {
    let isIos = false;
    let isAndroid = false;

    versions.filter((item: Version) => item.platform === "IOS").length > 0
      ? (isIos = true)
      : (isIos = false);

    versions.filter((item: Version) => item.platform === "ANDROID").length > 0
      ? (isAndroid = true)
      : (isAndroid = false);

    if (isIos && !isAndroid) {
      setPlatform("iOS");
    } else if (!isIos && isAndroid) {
      setPlatform("Android");
    } else if (isIos && isAndroid) {
      setPlatform("Android; iOS;");
    }
  }

  const prefix = "itms-services://?action=download-manifest&url=";
  const linkTextAndroid = props.auth
    ? "download/auth/" + uuid + "/ANDROID"
    : "download/" + uuid + "/ANDROID";
  const linkTextIOS = props.auth
    ? "download/auth/" + uuid + "/IOS"
    : "download/" + uuid + "/IOS";
  const manifestLink = linkTextIOS + "?installOnIOS=true";

  if (process.env.NODE_ENV === "production") {
    if (window.location.port) {
      urlForManifest =
        prefix +
        encodeURIComponent(
          "https://" +
            window.location.hostname +
            ":" +
            window.location.port +
            process.env.REACT_APP_BACKEND_BASE_URL +
            manifestLink
        );
    } else {
      urlForManifest =
        prefix +
        encodeURIComponent(
          "https://" +
            window.location.hostname +
            process.env.REACT_APP_BACKEND_BASE_URL +
            manifestLink
        );
    }
  } else {
    urlForManifest =
      prefix +
      encodeURIComponent(process.env.REACT_APP_BACKEND_BASE_URL + manifestLink);
  }

  const getProgress = (
    validity_end_date: string,
    validity_start_date: string
  ) => {
    var now = new Date();
    var end = new Date(validity_end_date);
    var start = new Date(validity_start_date);

    const duration = end.getTime() - start.getTime();
    if (now.getTime() < start.getTime()) {
      setProgress(0);
    } else if (now.getTime() > end.getTime()) {
      setProgress(100);
    } else if (
      now.getTime() > start.getTime() &&
      now.getTime() < end.getTime()
    ) {
      setProgress(((now.getTime() - start.getTime()) / duration) * 100);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (link && progress <= 100)
        getProgress(link.validity_end, link.validity_start);
    }, 1000);
    return () => clearInterval(interval);
  }, [link, progress]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      {/* Standard link when Authentication is not required --> both authenticated and not authenticated users can access since the link is PUBLIC */}
      {link && !props.auth && (
        <div>
          {isAuthenticated && localStorage.getItem("Role") !== undefined ? (
            <Layout />
          ) : (
            <LoginLayout />
          )}

          {/*If the link is VALID, a further control on the operating system is performed: depending on the OS, different components are rendered. */}
          {compareTime(link.validity_end, link.validity_start) === "valid" ? (
            [
              <Box key="public">
                <UnauthenticatedTemplate>
                  <DownloadElements
                    platform={platform}
                    os={os}
                    link={link}
                    progress={progress}
                    linkTextAndroid={linkTextAndroid}
                    linkTextIOS={linkTextIOS}
                    urlForManifest={urlForManifest}
                  />
                </UnauthenticatedTemplate>
                <AuthenticatedTemplate>
                  <DownloadElements
                    platform={platform}
                    os={os}
                    link={link}
                    progress={progress}
                    linkTextAndroid={linkTextAndroid}
                    linkTextIOS={linkTextIOS}
                    urlForManifest={urlForManifest}
                  />
                </AuthenticatedTemplate>
              </Box>,
            ]
          ) : (
            /* If the link is expired, an ad hoc component is shown. */
            <LinkExpired
              validity={compareTime(link.validity_end, link.validity_start)}
              validity_start={link.validity_start}
              validity_end={link.validity_end}
            />
          )}
        </div>
      )}{" "}
      {
        /* Link when Authentication is required --> only authenticated users can access the page since the link is PRIVATE */
        props.auth && (
          <div>
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
            >
              {/* <AuthenticatedTemplate> */}
              {isAuthenticated && localStorage.getItem("Role") !== undefined ? (
                <Layout />
              ) : (
                <LoginLayout />
              )}
              <Box display="flex" alignItems="center" justifyContent="center">
                {inProgress !== InteractionStatus.None ||
                (acquiringToken && link === undefined) ? (
                  <LoadingPage />
                ) : (
                  !acquiringToken &&
                  link !== undefined && (
                    <Container>
                      {compareTime(link.validity_end, link.validity_start) ===
                      "valid" ? (
                        [
                          <Box key="private">
                            <DownloadElements
                              platform={platform}
                              os={os}
                              link={link}
                              progress={progress}
                              linkTextAndroid={linkTextAndroid}
                              linkTextIOS={linkTextIOS}
                              urlForManifest={urlForManifest}
                            />
                          </Box>,
                        ]
                      ) : (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <LinkExpired
                            validity={compareTime(
                              link.validity_end,
                              link.validity_start
                            )}
                            validity_start={link.validity_start}
                            validity_end={link.validity_end}
                          />{" "}
                        </Box>
                      )}
                    </Container>
                  )
                )}
              </Box>
            </MsalAuthenticationTemplate>
            <UnauthenticatedTemplate>
              <WelcomePage />
            </UnauthenticatedTemplate>
          </div>
        )
      }
      <div
        style={{
          position: "absolute",
          left: 0,
          bottom: 0,
          right: 0,
        }}
      >
        <Footer />
      </div>
    </Box>
  );
}

export default DownloadPage;

reportWebVitals();
